import { Platform } from "react-native";
import _ from "lodash";
import Dimensions from "react-native-web-dimension-helper";
// iPhoneX Xs or iPhone 12 mini
const X_WIDTH = 375;
const X_HEIGHT = 812;

// iPhoneXR XsMax
const XR_WIDTH = 414;
const XR_HEIGHT = 896;

// iPhone 12 or 12 pro
const PRO12_WIDTH = 390;
const PRO12_HEIGHT = 844;

// iPhone 11, 12 pro max
const MAX12_WIDTH = 428;
const MAX12_HEIGHT = 926;

// screen
const SCREEN_WIDTH = Dimensions.get("window").width;
const SCREEN_HEIGHT = Dimensions.get("window").height;

//  safe area padding
const HEADER_PADDING = 24;//safe area inset is 44, but we already has margin about 15 ~ 20 so we reduce it
const BOTTOM_PADDING = 34;

//x or xs
function isIphoneX() {
    return (
        Platform.OS === "ios" &&
        !Platform.isPad &&
        !Platform.isTVOS &&
        ((SCREEN_HEIGHT === X_HEIGHT && SCREEN_WIDTH === X_WIDTH) || (SCREEN_HEIGHT === X_WIDTH && SCREEN_WIDTH === X_HEIGHT))
    );
}

//xr or xs max
function isIphoneXR() {
    return (
        Platform.OS === "ios" &&
        !Platform.isPad &&
        !Platform.isTVOS &&
        ((SCREEN_HEIGHT === XR_HEIGHT && SCREEN_WIDTH === XR_WIDTH) || (SCREEN_HEIGHT === XR_WIDTH && SCREEN_WIDTH === XR_HEIGHT))
    );
}

//12 or 12 pro
function isIphone12PRO() {
    return (
        Platform.OS === "ios" &&
        !Platform.isPad &&
        !Platform.isTVOS &&
        ((SCREEN_HEIGHT === PRO12_HEIGHT && SCREEN_WIDTH === PRO12_WIDTH) || (SCREEN_HEIGHT === PRO12_WIDTH && SCREEN_WIDTH === PRO12_HEIGHT))
    );
}

//12 pro MAX
function isIphone12MAX() {
    return (
        Platform.OS === "ios" &&
        !Platform.isPad &&
        !Platform.isTVOS &&
        ((SCREEN_HEIGHT === MAX12_HEIGHT && SCREEN_WIDTH === MAX12_WIDTH) || (SCREEN_HEIGHT === MAX12_WIDTH && SCREEN_WIDTH === MAX12_HEIGHT))
    );
}

function isIphone() {
    return Platform.OS === "ios";
}

class iphonexHelper {
    constructor() {}

    get isIphoneX() {
        return isIphoneX();
    }

    get isIphoneXR() {
        return isIphoneXR();
    }

    get isIphone12PRO() {
        return isIphone12PRO();
    }

    get isIphone12MAX() {
        return isIphone12MAX();
    }

    get needFitIphoneX() {
        return isIphoneXR() || isIphoneX() || isIphone12PRO();
    }

    get fitIphoneXForHeader() {
        return {
            paddingTop: this.needFitIphoneX ? HEADER_PADDING : 0
        };
    }

    get fitForFooter() {
        return {
            paddingBottom: this.needFitIphoneX ? BOTTOM_PADDING : 0
        };
    }

    get fitForContainer() {
        return {
            paddingBottom: this.needFitIphoneX ? BOTTOM_PADDING : 0,
            paddingTop: this.needFitIphoneX ? HEADER_PADDING : 0
        };
    }

    get getHeightForHeader() {
        return this.needFitIphoneX ? HEADER_PADDING : 0;
    }

    get getHeightForFooter() {
        return this.needFitIphoneX ? BOTTOM_PADDING : 0;
    }

    calcPaddingForHeader(orgHeight) {
        orgHeight = _.isNumber(orgHeight) && orgHeight > 0 ? orgHeight : 0;
        if (!isIphone()) {
            return orgHeight;
        } else if(this.needFitIphoneX){
            return orgHeight + HEADER_PADDING;
        } else if(this.isIphone12MAX){  
            return orgHeight + HEADER_PADDING + 10;
        } else
        return orgHeight;
    }

    calcPaddingForBottom(orgHeight, extraHeightForIphoneX) {
        orgHeight = _.isNumber(orgHeight) && orgHeight > 0 ? orgHeight : 0;
        if (!isIphone()) {
            return orgHeight;
        }
        if (extraHeightForIphoneX) {
            return this.needFitIphoneX ? (extraHeightForIphoneX + BOTTOM_PADDING) : orgHeight;
        }
        return this.needFitIphoneX ? (Math.max(orgHeight, BOTTOM_PADDING)) : orgHeight;
    }

    calcHeightForHeader(orgHeight, extraHeightForIphoneX){
        orgHeight = _.isNumber(orgHeight) && orgHeight > 0 ? orgHeight : 0;
        if (!isIphone()) {
            return orgHeight;
        }
        if (extraHeightForIphoneX) {
            return this.needFitIphoneX ? (extraHeightForIphoneX + HEADER_PADDING) : orgHeight;
        }
        return this.needFitIphoneX ? (orgHeight + HEADER_PADDING) : orgHeight;
    }

    calcHeightForBottom(orgHeight, extraHeightForIphoneX) {
        orgHeight = _.isNumber(orgHeight) && orgHeight > 0 ? orgHeight : 0;
        if (!isIphone()) {
            return orgHeight;
        }
        if (extraHeightForIphoneX) {
            return this.needFitIphoneX ? (extraHeightForIphoneX + BOTTOM_PADDING) : orgHeight;
        }
        return this.needFitIphoneX ? (orgHeight + BOTTOM_PADDING) : orgHeight;
    }
}

const IPhoneXHelper = new iphonexHelper();

export default IPhoneXHelper;